import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface Editor {
    _id: string;
    fullName: string;
    email: string;
    specialization: string;
    assignedSubmissions: string[];
}

interface EditorContextType {
    editor: Editor | null;
    token: string | null;
    isAuthenticated: boolean;
    logout: () => void;
    loading: boolean;
}

const EditorContext = createContext<EditorContextType>({
    editor: null,
    token: null,
    isAuthenticated: false,
    logout: () => { },
    loading: true
});

export const useEditor = () => useContext(EditorContext);

export const EditorProvider = ({ children }: { children: ReactNode }) => {
    const [editor, setEditor] = useState<Editor | null>(null);
    const [token, setToken] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedToken = localStorage.getItem('editorToken');
        const storedEditor = localStorage.getItem('editorData');

        if (storedToken && storedEditor) {
            setToken(storedToken);
            setEditor(JSON.parse(storedEditor));
        }

        setLoading(false);
    }, []);

    const logout = () => {
        localStorage.removeItem('editorToken');
        localStorage.removeItem('editorData');
        setEditor(null);
        setToken(null);
        // This role is embedded as a tab inside the unified dashboard, so logging out
        // here should return to the unified login, not this role's standalone one.
        window.location.href = '/login';
    };

    return (
        <EditorContext.Provider value={{
            editor,
            token,
            isAuthenticated: !!token && !!editor,
            logout,
            loading
        }}>
            {children}
        </EditorContext.Provider>
    );
};
